import { render, staticRenderFns } from "./DeckCategory.vue?vue&type=template&id=7785597c&"
import script from "./DeckCategory.ts?vue&type=script&lang=ts&"
export * from "./DeckCategory.ts?vue&type=script&lang=ts&"
import style0 from "./DeckCategory.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports